import { Outlet } from "react-router-dom";
import FamilyBusinessNavbar from "./FamilyBusinessNavbar";
import FamilyBusinessFooter from "./FamilyBusinessFooter";

const FamilyBusinessLayout = () => {
    return (
        <div className="min-h-screen bg-white dark:bg-[#0F172A] flex flex-col text-gray-900 dark:text-white transition-theme overflow-hidden">
            <FamilyBusinessNavbar />
            <main className="grow pt-24 pb-20">
                <Outlet />
            </main>
            <FamilyBusinessFooter />
        </div>
    );
};

export default FamilyBusinessLayout;
